module.exports = __webpack_public_path__ + "img/social-icon-pr.87291a25.png";